document.addEventListener('DOMContentLoaded', function () {
  const SELECTS_QS = '.product-form__input select';
  const CUSTOM_OPT_QS = '[role="option"], .select__option'; // Craft sin “fake” liste

  const isSoldOutText = (t) => /utsolgt|sold\s*out/i.test(t || '');

  function markAndFixSelect(sel) {
    const opts = Array.from(sel.options);

    opts.forEach((opt) => {
      const label = (opt.textContent || '').trim();
      const soldOut = opt.disabled || opt.getAttribute('aria-disabled') === 'true' ||
                      opt.dataset.available === 'false' || isSoldOutText(label);

      if (soldOut) {
        opt.disabled = true;
        opt.setAttribute('aria-disabled', 'true');
      }

      // Speil til Craft “fake” dropdown
      const root = sel.closest('.product-form, form') || document;
      root.querySelectorAll(CUSTOM_OPT_QS).forEach(el => {
        const t = (el.getAttribute('data-value') || el.textContent || '').trim();
        if (t === label) {
          if (soldOut) el.setAttribute('aria-disabled', 'true');
          else el.removeAttribute('aria-disabled');
        }
      });
    });


  }

  function initAll() {
    const selects = document.querySelectorAll(SELECTS_QS);
    if (!selects.length) return;

    selects.forEach(markAndFixSelect);

    // Hindre klikk på “fake” utsolgte alternativer
    ['mousedown','click','pointerdown','touchstart'].forEach(evt => {
      document.addEventListener(evt, function (e) {
        const blocked = e.target.closest('[role="option"][aria-disabled="true"], .select__option[aria-disabled="true"]');
        if (blocked) { e.preventDefault(); e.stopImmediatePropagation(); }
      }, true);
    });

    // Kjør igjen når bruker endrer noe eller tema re-renderer
    document.addEventListener('change', function (e) {
      const sel = e.target.closest(SELECTS_QS);
      if (sel) markAndFixSelect(sel);
    }, true);

    const mo = new MutationObserver(() => {
      document.querySelectorAll(SELECTS_QS).forEach(markAndFixSelect);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  initAll();
});
